import React from "react";
import { colors, gradients, transition } from "../theme";

const InscriptionCardDirector = ({
  inscription,
  directorDecision,
  isReadOnly,
  isSaving,
  onAccord,
  onSurseoir,
  onOpenDecision,
}) => {
  const dd = directorDecision;

  return (
    <div className="d-flex flex-column" style={{ gap: 6 }}>
      {inscription.note && (
        <div
          style={{
            fontSize: 11,
            color: colors.info.text,
            background: colors.info.bg,
            border: `1px solid ${colors.info.border}`,
            borderRadius: 6,
            padding: "4px 8px",
            lineHeight: 1.4,
          }}
        >
          <i className="fa fa-sticky-note mr-1" />
          {inscription.note}
        </div>
      )}
      <div className="d-flex" style={{ gap: 6 }}>
        <button
          className="btn btn-sm flex-grow-1"
          onClick={() => onAccord(inscription)}
          disabled={isReadOnly || isSaving}
          style={{
            background:
              dd?.decision === "ACCORD" ? gradients.success : colors.bg.page,
            color:
              dd?.decision === "ACCORD" ? colors.text.white : colors.text.secondary,
            border:
              dd?.decision === "ACCORD"
                ? "none"
                : `1px solid ${colors.border.default}`,
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 700,
            padding: "6px 10px",
            transition,
          }}
        >
          {isSaving && dd?.decision !== "A_SURSEOIR" ? (
            <i className="fa fa-spinner fa-spin mr-1" style={{ fontSize: 10 }} />
          ) : (
            <i className="fa fa-check mr-1" style={{ fontSize: 10 }} />
          )}
          Accord
        </button>
        <button
          className="btn btn-sm flex-grow-1"
          onClick={() => onSurseoir(inscription)}
          disabled={isReadOnly || isSaving}
          style={{
            background:
              dd?.decision === "A_SURSEOIR"
                ? gradients.warning
                : colors.bg.page,
            color:
              dd?.decision === "A_SURSEOIR"
                ? colors.text.white
                : colors.text.secondary,
            border:
              dd?.decision === "A_SURSEOIR"
                ? "none"
                : `1px solid ${colors.border.default}`,
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 700,
            padding: "6px 10px",
            transition,
          }}
        >
          {isSaving && dd?.decision === "A_SURSEOIR" ? (
            <i className="fa fa-spinner fa-spin mr-1" style={{ fontSize: 10 }} />
          ) : (
            <i className="fa fa-pause-circle mr-1" style={{ fontSize: 10 }} />
          )}
          Surseoir
        </button>
      </div>
      {dd?.decision === "A_SURSEOIR" && dd?.comment && (
        <div
          style={{
            fontSize: 11,
            color: colors.warning.text,
            background: colors.warning.bg,
            border: `1px solid ${colors.warning.border}`,
            borderRadius: 6,
            padding: "4px 8px",
          }}
        >
          <i className="fa fa-comment mr-1" />
          {dd.comment}
        </div>
      )}
      <div className="d-flex align-items-center" style={{ gap: 6, marginTop: 2 }}>
        <button
          className="btn btn-sm"
          onClick={() => onOpenDecision(inscription)}
          style={{
            background: colors.bg.page,
            color: colors.text.secondary,
            border: `1px solid ${colors.border.default}`,
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 600,
            padding: "5px 10px",
            whiteSpace: "nowrap",
          }}
        >
          <i className="fa fa-eye mr-1" style={{ fontSize: 10 }} />
          Consulter
        </button>
      </div>
    </div>
  );
};

export default React.memo(InscriptionCardDirector);
